import React from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';

const Container = styled.div`
  @import 'stylesheets/design_system/_deprecated_grid.scss';
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 24px 24px 48px 24px;
  text-align: center;
  flex: 1;
  width: 100%;

  @include medium-up {
    border-radius: 6px;
    padding: 24px 16% 48px 16%;
  }
`;

export const BigCardWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <Container
      style={{
        backgroundImage: `url(${$image_url(
          'social/attention_card_background.svg',
        )})`,
      }}
    >
      {children}
    </Container>
  );
};
